import React from 'react';
import { ProgressProps } from 'semantic-ui-react';
import { Typography } from 'src/components/coreUI';

type Props = {
  renderLabel?: (per: number | string) => React.ReactNode;
  type?: 'line' | 'rectangular';
  labelClassName?: string;
} & ProgressProps;

const CustomProgress: React.FC<Props> = ({
  renderLabel,
  type,
  labelClassName,
  ...rest
}) => {
  return (
    <div className={`custom_progress mb-12 ${type || 'line'}`}>
      <Typography.Label className={labelClassName}>
        {renderLabel ? renderLabel(rest?.percent || 0) : rest?.percent}
      </Typography.Label>
      <progress value={rest.percent || 0} max={100} />
    </div>
  );
};

export default CustomProgress;
